<div #chartContainer class="w-full h-full relative"></div>
